<template>
  <div :v-if="displayRequestModalEditUrl">
    <v-edit-dialog
      @save="onClickSave"
      @cancel="onClickCancel"
      :save-text="okText"
      cancel-text="キャンセル"
      large
    >
      <div>
        <v-btn v-if="isWaitingStatus" @click="onClick" color="primary" small>
          <v-icon small>add</v-icon>
          {{ okText }}
        </v-btn>
        <v-btn
          v-if="isCompletedStatus"
          @click="onClick"
          color="green"
          small
          dark
        >
          <v-icon small>edit</v-icon>
          {{ okText }}
        </v-btn>
      </div>
      <template v-slot:input>
        <v-text-field
          v-model="inputUrl"
          label="マップレポートURL"
          class="url-text-field"
          autofocus
        />
      </template>
    </v-edit-dialog>
  </div>
</template>

<script>
import { MapReportStatuses } from '@/models/MapReport'

export default {
  name: 'AdminMapReportListButtonEditUrl',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: null,
    },
    status: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputUrl: this.url,
      displayRequestModalEditUrl: false,
      isValidError: true,
    }
  },
  computed: {
    okText() {
      if (this.isWaitingStatus) {
        return 'URL登録'
      } else {
        return 'URL更新'
      }
    },
    isWaitingStatus() {
      return this.status === MapReportStatuses.Waiting
    },
    isCompletedStatus() {
      return this.status === MapReportStatuses.Completed
    },
  },
  methods: {
    onClick() {
      this.inputUrl = this.url
      this.displayRequestModalEditUrl = true
    },
    async onClickSave() {
      try {
        this.$emit('updateUrl', this.id, this.inputUrl)
      } catch (e) {
        console.error(e)
        throw new Error('URL更新に失敗しました。')
      }
    },
    onClickCancel() {
      this.displayRequestModalEditUrl = false
      this.inputUrl = this.url
    },
  },
}
</script>

<style scoped>
.url-text-field {
  margin-top: 20px;
  width: 500px;
}
</style>
